export const TIME_PERIODS = [
	{ label: "30 days", value: "last30d" },
	{ label: "90 days", value: "last90d" },
	{ label: "1 year", value: "last1y" },
	{ label: "10 years", value: "last10y" },
] as const;

// Periods the backend calculates I&I summaries for.
export const I_AND_I_TIME_PERIODS = [
	{ label: "Last rainy day > 5 mm", value: "lastRainyDay5mm" },
	{ label: "7 days", value: "last7d" },
	{ label: "30 days", value: "last30d" },
	{ label: "90 days", value: "last90d" },
	{ label: "1 year", value: "last1y" },
] as const;

export const STRUCTURE_TIME_PERIODS = [
	{ label: "24 hours", value: "last24h" },
	{ label: "7 days", value: "last7d" },
	{ label: "14 days", value: "last14d" },
	{ label: "30 days", value: "last30d" },
	{ label: "90 days", value: "last90d" },
	{ label: "1 year", value: "last1y" },
] as const;

export type StructureTimePeriodsValue = (typeof STRUCTURE_TIME_PERIODS)[number]["value"];

export type TimePeriodsValue = (typeof TIME_PERIODS)[number]["value"];

export type IAndITimePeriodsValue = (typeof I_AND_I_TIME_PERIODS)[number]["value"];

export const DEFAULT_I_AND_I_TIME_PERIOD: IAndITimePeriodsValue = "last30d";
